import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "range-input" };
const _hoisted_2 = { class: "range-input__head" };
const _hoisted_3 = { class: "tilde" };
const _hoisted_4 = { class: "range-input__tail" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'RangeInput',
    props: {
        symbol: { default: '~' }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "head")
                ]),
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.symbol), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_4, [
                    _renderSlot(_ctx.$slots, "tail")
                ])
            ]));
        };
    }
});
